<template>
    <div
        class="font-sans-rubik z-100 fixed top-from-app-bar bottom-0 max-mb:w-full w-ai-bar-width-mini bg-white dark:bg-blue-800 max-mb:border-none border-l border-gray-100 dark:border-blue-720"
        :class="showAgent ? 'right-0' : 'max-mb:-right-full -right-ai-bar-width-mini'"
    >
        <div class="flex flex-col h-full">
            <div ref="headerRef">
                <slot name="header"></slot>
            </div>

            <slot></slot>
        </div>
    </div>
</template>

<script setup>
const showAgent = defineModel('modelValue', { type: Boolean, default: false })
</script>
